import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelineMappingsPage } from '@Integrations/Pipelines/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminConfigurePipelineMappingPage',
  setup(__props) {

    document.title = "Configure mappings"

    const tid = useOrganizationUnitId()
    const id = useId()

    const connectorId = ref()

    const idPropertyNameForConnector = ref()
    const idPropertyNameForDataset = ref()

    const idPropertyNamesForConnector = ref([])
    const idPropertyNamesForDataset = ref([])

    const nameForConnector = ref()
    const nameForDataset = ref()

    const {
        useCurrentUserQuery,
        usePipelineDetailsQuery,
        useConnectorPropertyNamesQuery,
        useAddPropertyNameMappingCommand,
        useRemovePropertyNameMappingCommand
    } = useAdminConfigurePipelineMappingsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const direction = computed(() => modelPipelineDetailsQueryV1.value?.Direction)
    const properties = computed<string>(() => modelPipelineDetailsQueryV1.value?.Properties ?? [])
    const mappings = computed(() => modelPipelineDetailsQueryV1.value?.Mappings || [])

    const { runConnectorPropertyNamesQueryV1, modelConnectorPropertyNamesQueryV1 } = useConnectorPropertyNamesQuery(connectorId)
    const propertyNames = computed(() => modelConnectorPropertyNamesQueryV1.value?.PropertyNames || [])

    const { invokeAddPropertyNameMappingCommandV1, succeedAddPropertyNameMappingCommandV1 } = useAddPropertyNameMappingCommand(id, tid, userId, nameForConnector, nameForDataset)
    const { invokeRemovePropertyNameMappingCommandV1, succeedRemovePropertyNameMappingCommandV1 } = useRemovePropertyNameMappingCommand(id, tid, userId)

    const availablePropertyNames = computed(() => properties.value.length > 0 ? properties.value : propertyNames.value)

    function handleAddPropertyNameMappingCommand() {
        invokeAddPropertyNameMappingCommandV1()
    }

    function handleRemovePropertyNameMappingCommandV1(mapping: any) {
        invokeRemovePropertyNameMappingCommandV1({
            nameForConnector: mapping.NameForConnector,
            nameForDataset: mapping.NameForDataset,
        })
    }

    watch(modelPipelineDetailsQueryV1, () => {
        connectorId.value = modelPipelineDetailsQueryV1.value.ConnectorId
    })

    watch(connectorId, () => runConnectorPropertyNamesQueryV1())

    watch(succeedAddPropertyNameMappingCommandV1, () => runPipelineDetailsQueryV1())
    watch(succeedRemovePropertyNameMappingCommandV1, () => runPipelineDetailsQueryV1())

    watch(succeedAddPropertyNameMappingCommandV1, () => {
        nameForConnector.value = ''
        nameForDataset.value = ''
    })

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDetailsQueryV1()
    })

return { __sfc: true,tid, id, connectorId, idPropertyNameForConnector, idPropertyNameForDataset, idPropertyNamesForConnector, idPropertyNamesForDataset, nameForConnector, nameForDataset, useCurrentUserQuery, usePipelineDetailsQuery, useConnectorPropertyNamesQuery, useAddPropertyNameMappingCommand, useRemovePropertyNameMappingCommand, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1, direction, properties, mappings, runConnectorPropertyNamesQueryV1, modelConnectorPropertyNamesQueryV1, propertyNames, invokeAddPropertyNameMappingCommandV1, succeedAddPropertyNameMappingCommandV1, invokeRemovePropertyNameMappingCommandV1, succeedRemovePropertyNameMappingCommandV1, availablePropertyNames, handleAddPropertyNameMappingCommand, handleRemovePropertyNameMappingCommandV1 }
}

})